import React from 'react';

const AnomalyDetectionContext = React.createContext();

export const AnomalyDetectionProvider = AnomalyDetectionContext.Provider;
export const useAnomalyDetectionContext = () => React.useContext(AnomalyDetectionContext);
